var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "integralUser seller-style" }, [
    _c("h2", { staticClass: "f18 fb normal gray_2" }, [
      _vm._v("积分管理-积分汇总")
    ]),
    _c("div", { staticClass: "box30" }),
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "flex align_center" },
          [
            _c("div", { staticClass: "lable" }, [_vm._v("客户：")]),
            _c("el-input", {
              staticClass: "w240",
              attrs: { placeholder: "请输入客户名称或联系电话" },
              model: {
                value: _vm.selVal,
                callback: function($$v) {
                  _vm.selVal = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "selVal"
              }
            }),
            _c("div", { staticClass: "lable" }, [_vm._v("时间：")]),
            _c("el-date-picker", {
              staticClass: "mar20_r",
              attrs: {
                type: "daterange",
                "value-format": "yyyy-MM-dd HH:mm:ss",
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "popper-class": "seller-style",
                "default-time": ["00:00:00", "23:59:59"]
              },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            }),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.getPointsDtl } },
              [_vm._v("查询")]
            )
          ],
          1
        ),
        _c("div", { staticClass: "box30" }),
        _c(
          "el-table",
          {
            attrs: { border: "", data: _vm.list, "row-class-name": "pointer" }
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "name",
                label: "客户名称",
                "min-width": "15%"
              }
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "phone",
                label: "联系电话",
                "min-width": "15%"
              }
            }),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "grantPoints",
                  label: "收入",
                  "min-width": "15%"
                }
              },
              [
                _c("template", { slot: "header" }, [
                  _c(
                    "span",
                    [
                      _vm._v("收入\n            "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "说明：积分收入包含积分获得、积分回退",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ])
              ],
              2
            ),
            _c(
              "el-table-column",
              {
                attrs: { prop: "usedPoints", label: "支出", "min-width": "15%" }
              },
              [
                _c("template", { slot: "header" }, [
                  _c(
                    "span",
                    [
                      _vm._v("支出\n            "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            content: "说明：积分支出包含积分消耗、积分过期",
                            placement: "top-start"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }